import condriLogo from "@/assets/condri-without-background.png"
import { AppStoreButtons } from "@/components/ui/AppStores/AppStoreButtons"
import { Button } from "@/components/ui/button"
import { Shield } from "lucide-react"

const LoginPage = () => {
  return (
    <div className="min-h-screen max-w-md mx-auto bg-card flex flex-col">
      {/* Main content */}
      <div className="flex-1 flex flex-col justify-center px-6 pt-8">
        <div className="text-center space-y-6">
          <div className="mx-auto w-20 h-20 bg-primary-faded rounded-full flex items-center justify-center p-2">
            <img
              src={condriLogo}
              alt="Condri Logo"
              className="w-full h-full object-contain"
            />
          </div>

          <div className="space-y-3">
            <h1 className="text-3xl font-bold text-foreground">
              Welcome to Condri
            </h1>
            <p className="text-muted-foreground text-lg">
              Condri is a mobile app. Download it to get started.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom section */}
      <div className="flex flex-1 flex-col px-6 pb-6 space-y-6">
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground text-center">
            Download the Condri app to access your account and start your journey.
          </p>
          <AppStoreButtons />
        </div>

        <div className="relative py-4">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t border-border" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-card px-4 text-muted-foreground font-medium">
              Staff Member?
            </span>
          </div>
        </div>

        <div className="text-center">
          <Button variant="outline" asChild className="w-full">
            <a href="/auth/staff-login">
              <Shield className="mr-2 h-4 w-4" />
              Staff Login
            </a>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
